import Awards from '@/services/Api/Awards/Awards';

export default {
  computed: {
    mx_awardId() {
      return this.$route.params.award;
    },
  },
  methods: {
    async mx_fetchAward() {
      const { data } = await Awards.get(this.mx_awardId);
      this.award = data?.data;
    },
  },
};
